import { getEcho } from '@/shared/lib/echo';
import { useMemo, type ReactNode } from 'react';
import { EchoContext, type EchoContextValue } from './echo-context';

interface EchoProviderProps {
    userId: number | null;
    children: ReactNode;
}

/**
 * Wraps the React tree with the Reverb/Echo singleton + the current user id.
 * Concrete listener hooks (e.g. `useNotificationsRealtime`) consume the
 * context and subscribe to the right private channel.
 */
export function EchoProvider({ userId, children }: EchoProviderProps) {
    const value = useMemo<EchoContextValue>(() => ({ echo: getEcho(), userId }), [userId]);
    return <EchoContext.Provider value={value}>{children}</EchoContext.Provider>;
}
